import html from './questionnaire.html';
import lang from './questionnaire.lang.json';
import server from '../../../client/asis-server.js';
import * as directives from '../../../client/globals/directives.js';
import * as validators from '../../../client/globals/validators.js';
import * as mixins from '../../../client/globals/mixins.js';
import component_choice_single from './components/choice-single.js';
import component_choice_multiple from './components/choice-multiple.js';


export default {
    template: html,

    i18n: {
        messages: lang
    },

    mixins: [
        mixins.loadDataOnCreate, 
        mixins.hasRole, 
        directives.label_required, 
        validators.vuelidate,
        mixins.storeGetters(['lang'],'asis/ui'),
    ],

    components: {
        'choice-single': component_choice_single,
        'choice-multiple': component_choice_multiple,
    },

    data: function() {
        return {
            poll: {},                                   // definition of the poll
            responded: false,                           // user has responded before
            responses: {},                              // user responses
            comments: {},                              // user comments to responses
            submit_error: null,                         // soft error
        };
    },

    validations() {
        var rules = {};

        if (this.poll.questions && this.poll.questions.length) {
            this.poll.questions.forEach(q => {
                rules[q.question_id] = { required: validators.required }
            })
        }

        console.log('Validations rules:', rules);
        return {
            responses: rules
        }
    },

    methods: {
        load() {
            server.request(
                this.$parent.module_name, 'poll-get',
                this.$route.params, null,
                (data, extra)=>{
                    this.poll = data;
                    this.responded = extra.responded;
                    // if the poll is anonymous and the user has already responded, hide questions
                    if (this.poll.anonymous && this.responded) this.poll.questions = [];

                    // load existing responses & comments
                    if (extra.responses && extra.responses.constructor === Object) this.responses = extra.responses;
                    if (extra.comments  && extra.comments.constructor === Object) this.comments = extra.comments;

                    // reset validation state after structure change
                    this.$nextTick(() => {
                        if (this.$v) this.$v.$reset();
                    });
                },
                (error)=>{
                    this.$bvModal.msgBoxOk(this.$t(error), {centered:true})
                    .then(v=>{
                        this.$router.push('/');
                    })
                    .catch(e=>{});
                }
            );
        },

        submit() {
            // check if the form validates
            if (this.$v.$invalid) return;

            this.submit_error = null;
            server.request(
                this.$parent.module_name, 'poll-save', 
                {poll_id:this.poll.poll_id, secret:this.poll.secret, responses:this.responses, comments:this.comments}, null, 
                (data) => {
                    // if ok, go to previous view
                    this.$bvModal.msgBoxOk(this.$t('saved'), {centered:true})
                    .then(v=>{
                        // if ok, go to home screen
                        if (this.poll.anonymous) this.$router.push('/');
                    })
                    .catch(e=>{});
                }, 
                (error) => {
                    this.submit_error = error;
                }
            );
            return false;
        },

        clear_answer(question_id) {
            this.$delete(this.responses, question_id);
            this.$delete(this.comments, question_id);
            this.$v.responses[question_id].$reset();
        }

    }
};

